export const normalizeRole = (roleName = "") => roleName
  .normalize("NFD")
  .replace(/[\u0300-\u036f]/g, "")
  .replace(/[-_]/g, " ")
  .trim()
  .toUpperCase()

export const isInventoryManager = (roleName) => {
  const role = normalizeRole(roleName)
  return role.includes("GESTOR") && role.includes("INVENTARIO")
}

export const canManageDocuments = (roleName) => [
  "ADMIN",
  "ADMINISTRADOR",
  "SUPER ADMIN",
  "SUPERADMIN",
].includes(normalizeRole(roleName))

export const isSuperAdmin = (roleName) => ["SUPER ADMIN", "SUPERADMIN"].includes(normalizeRole(roleName))

export const hasPermission = (role, codigo) => {
  if (isSuperAdmin(role?.nombre)) return true
  return (role?.permisos || []).some((permiso) => permiso.codigo === codigo)
}

export const getAllowedViews = (role) => {
  if (isSuperAdmin(role?.nombre)) return ["dashboard", "inventario", "ubicaciones", "usuarios", "roles", "reporte", "clientes", "ventas", "pendientes", "blog", "configuracion"]
  const permissionViews = [
    ["dashboard.ver", "dashboard"],
    ["inventario.ver", "inventario"],
    ["ubicaciones.ver", "ubicaciones"],
    ["pedidos.ver", "pendientes"],
    ["clientes.ver", "clientes"],
    ["ventas.ver", "ventas"],
    ["reportes.ver", "reporte"],
    ["blog.gestionar", "blog"],
  ].filter(([codigo]) => hasPermission(role, codigo)).map(([, vista]) => vista)
  if (permissionViews.length) return permissionViews
  const views = (role?.vistas || []).map((view) => view.nombre?.toLowerCase?.()).filter(Boolean)
  return views
}
